import React, {useEffect, useState} from "react";
import {signUpApi} from "../../api/signup.js";
import {useParams} from "react-router-dom";
import {Spinner} from "react-bootstrap";
import {loadStripe} from '@stripe/stripe-js';
import {
    PaymentElement,
    Elements,
    useStripe,
    useElements,
} from '@stripe/react-stripe-js';

function ActivateResellerPage() {
    const { activationKey } = useParams();
    const [pageState, setPageState] = useState({
        loading: false,
        onboardingInfo: null
    });


    useEffect(() => {
        setPageState(prevState => {
            return {...prevState, loading: true};
        });
        const activateAndGetData = async () => {
            const stripe = await loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY);
            await signUpApi.activateUserAccount(activationKey);
            let onboardingInfo = await signUpApi.getResellerOnboardingInfo(activationKey);
            setPageState(prevState => {
                return {...prevState, loading: false, onboardingInfo: onboardingInfo};
            });

            const {setupIntent, error} = await stripe.confirmAcssDebitSetup(
                onboardingInfo.clientSecret,
                {
                    payment_method: {
                        billing_details: {
                            name: onboardingInfo.organizationName,
                            email: onboardingInfo.email,
                        },
                    },
                }
            );
            console.log('setupIntent',setupIntent);
            console.log('error',error);
        }

        activateAndGetData().catch(console.error).finally(() =>{
            setPageState(prevState => {
                return {...prevState, loading: false};
            });
        });
    }, [activationKey]);

    return (
        <>
        <h1>Finish Reseller Onboarding</h1>
        {pageState.loading ? <Spinner/> : (
            <>
                <h2>company info</h2>
                <form id='payment-form'>

                </form>
            </>
        )}
        </>

    )
}

export default ActivateResellerPage;
